module.exports = __webpack_public_path__ + "static/media/nz.380c4a3a.svg";